// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__BwVZQ","wrapper":"Layout_wrapper__FZwdl"};